export const isOneDomain = process.env.REACT_APP_ONE_DOMAIN === 'true';

export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
